import React from "react";

import ClearIcon from "@mui/icons-material/Clear";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

import styles from "./ResultsViewModal.module.scss";

import { TopicQuizLists, TopicTitles } from "@/constants/common";
import { Answer, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";

interface CheckboxModalProps {
  open: boolean;
  quizName: SecurityTopicEnum;
  results: Array<string>;
  onClose: () => void;
}

const ResultsViewModal: React.FC<CheckboxModalProps> = ({
  open,
  results,
  onClose,
  quizName,
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={onClose}
      classes={{ paper: styles.paper }}
    >
      <DialogTitle classes={{ root: styles.title }}>
        <Grid container flexDirection="column">
          <Grid item xs={12} className={styles.topTitle}>
            <Typography fontSize="24px" fontWeight={450}>
              Results
            </Typography>
            <IconButton onClick={onClose}>
              <ClearIcon fontSize="medium" />
            </IconButton>
          </Grid>
          <Grid item xs={12} className={styles.bottomTitle}>
            <Typography fontSize="20px" fontWeight={500}>
              {TopicTitles[quizName]}
            </Typography>
            <div className={styles.score}>
              <Typography fontSize="16px" fontWeight={450}>
                Total score
              </Typography>
              <div className={styles.scoreCount}>
                <Typography fontSize="16px">
                  {results.filter(result => result === Answer.Correct).length}/
                  {results.length}
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: styles.content }}>
        {TopicQuizLists[quizName].map((quiz, index) => {
          const currentAnswer = results[index];
          const incorrectAnswer = currentAnswer !== Answer.Correct;
          return (
            <div
              className={`${styles.buttonsContainer} ${
                incorrectAnswer ? styles.incorrect : undefined
              }`}
              key={quiz.name}
            >
              <FormControl component="fieldset">
                <FormLabel component="legend">{quiz.question}</FormLabel>
                <RadioGroup row={false} value={currentAnswer}>
                  {quiz.options.map(option => (
                    <FormControlLabel
                      key={option.value}
                      value={option.value}
                      control={<Radio />}
                      label={option.label}
                      className={
                        incorrectAnswer ? styles.redChecked : undefined
                      }
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          );
        })}
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default ResultsViewModal;
